import { useShallow } from 'zustand/react/shallow';

import { useAssetStore } from './slice';

export const useAssetState = () =>
    useAssetStore(
        useShallow(state => ({
            userSubscriptionInfo: state.userSubscriptionInfo,
            walletBalanceInfo: state.walletBalanceInfo,
            isVip: state.isVip,
        }))
    );

export const useAssetActions = () =>
    useAssetStore(
        useShallow(state => ({
            setAssetInfo: state.setAssetInfo,
            clearAssetInfo: state.clearAssetInfo,
        }))
    );

export const useUserSubscriptionInfo = () => useAssetStore(state => state.userSubscriptionInfo);
export const useWalletBalanceInfo = () => useAssetStore(state => state.walletBalanceInfo);
export const useIsVip = () => useAssetStore(state => state.isVip);
/** 支付确认成功信号；业务组件按权益类型完成各自的刷新。 */
export const usePaymentSuccessSignal = () => useAssetStore(state => state.paymentSuccessSignal);
/** Reader 支付成功对应的目标章节；空字符串表示非 Reader 场景或旧链路。 */
export const usePaymentSuccessChapterId = () => useAssetStore(state => state.paymentSuccessChapterId);
